import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
    providedIn: 'root'
})
export class BreadcrumbService {
    private breadcrumbsSource = new BehaviorSubject<IBreadcrumbItem[]>([]);
    breadcrumbs$ = this.breadcrumbsSource.asObservable();

    updateBreadcrumbs(breadcrumbs: IBreadcrumbItem[]) {
        this.breadcrumbsSource.next(breadcrumbs);
    }
}

interface IBreadcrumbItem {
    text: string;
    url: string;
}

